// extracted by mini-css-extract-plugin
export var icon = "TopScroller-module--icon--b2c20";